export default "/images/wildfire-response-program.jpg";